import { makeFetchData } from "api/makeApiRequestType/makeFetchData";
import { ValidationCallback } from "validation/validate";

export type Output = { userExists: boolean };

export const flagValidationErrors: ValidationCallback<Output> = (
	input,
	{ flag, checkField },
	auth
) => {
	checkField("userExists", { type: "boolean" });
};

type Params = {
	vanityUrl?: string;
	uid?: string;
};

export const getUserExists = makeFetchData<Params, Output>(
	"userExists",
	flagValidationErrors
);
